import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';

@Component({
  selector: 'cv-configure-folders',
  templateUrl: './configure-folders.component.html',
  styleUrls: ['./configure-folders.component.scss']
})
export class ConfigureFoldersComponent {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  folders = [];
  isSelected: boolean = false;
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    private cvConfigurationService: CvConfigurationService,
  ) {
    this.gs = this.gamesService.data;
  }

  ngOnInit() {
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  getFolderList(): any {
    //Load name of folders
    for (var i = 0; i < this.gs.GameFolders.length; i++) {
      if (this.folders.filter((f) => { return f == this.gs.GameFolders[i].FolderData.FolderName }).length == 0 && this.gs.GameFolders[i].FolderData.FolderName != "") {
        this.folders.push(JSON.parse(JSON.stringify(this.gs.GameFolders[i].FolderData.FolderName)));
      }
    }
    return this.folders;
  }

  onFolderSelected(folder: any): void {
    var folderSelected = this.gs.GameFolders.filter((f: any) => { return f.FolderData.FolderName == folder });
    if (folderSelected.length > 0) {
      this.gs.modified.item.underlyingRule.FolderID = folderSelected[0].FolderData.FolderID;
      this.isSelected = true;
    }
  }

  folderNameChanged(): void {
    if (this.gs.modified.item.underlyingRule.RuleFolder.length > 0) {
      //unlock next step
      var eventArgs = {
        currentStep: this.step - 1,
        unlocks: this.componentOptions.unlocks
      };
      this.componentComplete.emit(eventArgs);
    }
  }
}
